module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-fill"
  }, [_c('div', {
    staticClass: "container py-3"
  }, [_c('div', {
    staticClass: "row justify-content-center h-100"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "d-flex flex-column w-100 h-100"
  }, [_c('div', {
    staticClass: "flex-grow-1"
  }, [_vm._m(0), _vm._v(" "), (_vm.reservation) ? _c('tab-billing-details', {
    attrs: {
      "reservation": _vm.reservation,
      "readOnly": _vm.isReservationReadOnly && _vm.reservation.status != -5 || _vm.getIsSavingReservation,
      "showInvoiceBtn": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.reservation && _vm.reservation.bookingInvoices && _vm.reservation.bookingInvoices.length > 0) ? _c('div', {
    staticClass: "tab-invoices__invoice-list--limited mb-3 panel p-0 border-top-lightest"
  }, [_c('invoice-list', {
    attrs: {
      "invoiceList": _vm.reservation.bookingInvoices
    },
    on: {
      "toggleInvoiceModal": _vm.toggleInvoiceModal
    }
  })], 1) : (_vm.getShowInvoiceOption) ? _c('div', {
    staticClass: "dark fs-large text-center m-5 mt-5"
  }, [_vm._v("It seems you have no invoices.\n                        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.isToShowInvoicing) ? _c('div', {
    staticClass: "d-flex justify-content-end align-items-center text-right border-top-medium pt-2"
  }, [_c('div', {
    staticClass: "col-3"
  }, [(!_vm.getIsDocumentTypesLoading) ? _c('v-select', {
    attrs: {
      "options": _vm.documentTypesOptions,
      "label": "label",
      "value": _vm.documentTypeSelected
    },
    on: {
      "input": _vm.updateDocType
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.getIsDocumentTypesLoading) ? _c('div', [_c('loader')], 1) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.disableTooltip),
      expression: "disableTooltip"
    }],
    staticClass: "btn blue btn-height",
    attrs: {
      "disabled": _vm.getIsSavingReservation || _vm.isReservationReadOnly && _vm.reservation.status != -5 || !_vm.getShowInvoiceOption || !_vm.documentTypeSelected
    },
    on: {
      "click": _vm.startCreateInvoice
    }
  }, [_vm._v("Create Invoice")])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "mb-2 bold fs-normal d-flex justify-content-between"
  }, [_c('span', [_vm._v("Billing Details")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c265f99e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/TabInvoices/TabInvoices.vue
// module id = 1742
// module chunks = 0